import CardSeplag from "../../../../../components/CardSeplag";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Fieldset } from "primereact/fieldset";
import RotuloSeplag from "../../../../../components/RotuloSeplag";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useEffect, useState, useRef } from "react";
import {
  buscarPorExercicioTipoItem,
  getAllOrgao,
  getAllPrograma,
  getAllUo,
  getObjetivo,
} from "../../../../../service/Rag/Exercicio";
import { Button } from "primereact/button";
import CadastroProrrogacao from "./CadastroProrrogacao";
import { Toast } from "primereact/toast";
import ItensProrrogacao from "./ItensProrrogacao";

const Prorrogacao = ({ cronograma, exercicio, setProrrogacao }) => {
  const [visibleCadastroProrrogacao, setVisibleCadastroProrrogacao] = useState(false);
  const [visibleItemsProrrogado, setVisibleItemsProrrogado] = useState(false);
  const [orgaos, setOrgaos] = useState([]);
  const [orgaoSelected, setOrgaoSelected] = useState(null);
  const [programaSelected, setProgramaSelected] = useState(null);
  const [programasList, setProgramasList] = useState([]);
  const [uos, setUos] = useState([]);
  const [uoSelected, setUoSelected] = useState(null);
  const [arvoreRag, setArvoreRag] = useState([]);
  const [objetivos, setObjetivos] = useState([]);
  const [objetivoSelected, setObjetivoSelected] = useState(null);
  const [indicadoresList, setIndicadoresList] = useState([]);
  const [prorrogacoesList, setProrrogacoesList] = useState([]);
  const [acoesList, setAcoesList] = useState([]);
  const [atualizaList, setAtualizaList] = useState(false);
  const toast = useRef(null);

  const closeCronograma = (_cronograma) => {
    setProrrogacao(false);
  };

  const handleChangeObjetivos = (e) => {
    setIndicadoresList(e.value.indicadores);
  };

  const cadastroProrrogacao = () => {
    if (orgaoSelected === null) {
      return window.$toast.current.show({
        severity: "error",
        summary: "Selecione um Órgão",
        detail: '"Selecione um Órgão para prosseguir"',
        life: 5000,
      });
    }

    if (cronograma.tipoItemRag === "P" && uoSelected === null) {
      return window.$toast.current.show({
        severity: "error",
        summary: "Selecione uma UO",
        detail: '"Selecione uma UO para prosseguir"',
        life: 5000,
      });
    }

    if (cronograma.tipoItemRag === "A" && programaSelected === null) {
      return window.$toast.current.show({
        severity: "error",
        summary: "Selecione um programa",
        detail: '"Selecione um programa para prosseguir"',
        life: 5000,
      });
    }

    if (cronograma.tipoItemRag === "I" && objetivoSelected === null) {
      return window.$toast.current.show({
        severity: "error",
        summary: "Selecione um objetivo",
        detail: '"Selecione um objetivo para prosseguir"',
        life: 5000,
      });
    }

    return setVisibleCadastroProrrogacao(true);
  };

  const getItemsProrrogacoes = async () => {
    if ((cronograma.tipoItemRag === "I" || cronograma.tipoItemRag === "A") && programaSelected === null) {
      return window.$toast.current.show({
        severity: "error",
        summary: "Selecione um programa",
        detail: "Selecione um programa para pesquisar",
        life: 5000,
      });
    }

    if (cronograma.tipoItemRag === "P" && uoSelected === null) {
      return window.$toast.current.show({
        severity: "error",
        summary: "Selecione uma UO",
        detail: "Selecione uma UO para pesquisar",
        life: 5000,
      });
    }

    let dadosPesquisa = {
      idenExercicio: exercicio != null ? exercicio.exercicio.idenExercicio : null,
      idenOrgao: orgaoSelected != null ? orgaoSelected.idenOrgao : null,
      idenUo: uoSelected.idenUo != null ? uoSelected.idenUo : null,
      idenPrograma: programaSelected != null ? programaSelected.idenPrograma : null,
      idenObjetivo: objetivoSelected != null ? objetivoSelected.idenObjetivo : null,
      tipoItemRag: cronograma.tipoItemRag,
    };

    await buscarPorExercicioTipoItem(dadosPesquisa).then((res) => {
      setProrrogacoesList(res.data);
      setVisibleItemsProrrogado(true);
    });
  };

  useEffect(() => {
    getAllOrgao(exercicio.exercicio.idenExercicio).then((res) => {
      setOrgaos(res.data);
    });
  }, [exercicio.exercicio.idenExercicio]);

  useEffect(() => {
    if (orgaoSelected !== null) {
      getAllUo(orgaoSelected.idenOrgao).then((res) => {
        setUos(res.data);
      });
    }
  }, [orgaoSelected]);

  useEffect(() => {
    if (uoSelected !== null) {
      let dataProgramas = [];
      getAllPrograma(orgaoSelected?.idenOrgao, uoSelected.idenUo).then((res) => {
        setArvoreRag(res.data.content);

        res.data?.content.forEach((element) => {
          dataProgramas.push(element.programa);
        });

        setProgramasList(dataProgramas);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uoSelected, orgaoSelected?.idenOrgao]);

  useEffect(() => {
    if (programaSelected !== null) {
      if (["A"].includes(cronograma.tipoItemRag)) {
        let acoesPtaMonitora = [];
        let acoes_temp = arvoreRag.filter((element) => {
          return element.programa.idenPrograma === programaSelected.idenPrograma;
        });
        acoes_temp[0].children.forEach((element) => {
          getObjetivo(element.idenPtaFiplan).then((res) => {
            acoesPtaMonitora.push(res.data);
          });
        });
        setAcoesList(acoesPtaMonitora);
      }
      if (["I"].includes(cronograma.tipoItemRag)) {
        setObjetivos(
          programaSelected.objetivos.map((objeto) => {
            return { ...objeto, label: `${objeto.codgObjetivo} - ${objeto.nomeObjetivo}` };
          })
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programaSelected]);

  useEffect(() => {
    if (atualizaList === true) {
      getItemsProrrogacoes();
      setAtualizaList(false);
    }
  }, [atualizaList]);
  return (
    <CardSeplag title="Prorrogação">
      <Toast ref={toast} />
      <DataTable value={[cronograma]} showGridlines responsiveLayout="scroll">
        <Column field="descCronograma" header="Descrição do cronograma"></Column>
        <Column field="dataInicial" header="Data Inicial"></Column>
        <Column field="dataFinal" header="Data Final"></Column>
      </DataTable>
      <br />
      <Fieldset legend="Dados da prorrogação">
        <form>
          <div className="p-fluid grid">
            <div className="field col-12 md:col-3 ">
              <RotuloSeplag nome={"Exercício"}>
                <InputText
                  placeholder="Selecione o Exercício"
                  id="exercicio"
                  name="exercicio"
                  disabled={true}
                  value={exercicio.exercicio.ano}
                />
              </RotuloSeplag>
            </div>
            <div className="field col-12 md:col-3">
              <RotuloSeplag nome="Órgão">
                <Dropdown
                  placeholder="Selecione o Órgão do Exercício"
                  id="descricaoFiplan"
                  name="descricaoFiplan"
                  optionLabel="descricaoFiplan"
                  value={orgaoSelected}
                  options={orgaos}
                  onChange={(e) => setOrgaoSelected(e.value)}
                />
              </RotuloSeplag>
            </div>
            <div className="field col-12 md:col-3">
              <RotuloSeplag nome="U.O." cols="12 3">
                <Dropdown
                  placeholder="Selecione o UO do Exercício"
                  id="descricaoFiplan"
                  name="descricaoFiplan"
                  optionLabel="descricaoFiplan"
                  value={uoSelected}
                  options={uos}
                  onChange={(e) => setUoSelected(e.value)}
                />
              </RotuloSeplag>
            </div>
            {["A", "I"].includes(cronograma.tipoItemRag) && (
              <div className="field col-12 md:col-3">
                <RotuloSeplag nome="Programa" cols="12 3">
                  <Dropdown
                    placeholder="Selecione o Programa"
                    id="descricaoFiplan"
                    name="descricaoFiplan"
                    optionLabel="descricaoFiplan"
                    value={programaSelected}
                    options={programasList}
                    onChange={(e) => setProgramaSelected(e.value)}
                  />
                </RotuloSeplag>
              </div>
            )}
          </div>

          <div className="p-fluid grid line-height-6">
            {["I"].includes(cronograma.tipoItemRag) && (
              <div className="field col-12 md:col-6">
                <RotuloSeplag nome="Objetivo" cols="12 6">
                  <Dropdown
                    placeholder="Selecione o Objetivo"
                    id="descricaoFiplan"
                    name="descricaoFiplan"
                    optionLabel="label"
                    value={objetivoSelected}
                    options={objetivos}
                    onChange={(e) => {
                      setObjetivoSelected(e.value);
                      handleChangeObjetivos(e);
                    }}
                  />
                </RotuloSeplag>
              </div>
            )}
            <div className="field col-12 md:col-4"></div>
          </div>
          <div className="p-fluid grid">
            <div className="field col-12 md:col-4">
              <Button type="button" onClick={closeCronograma}>
                <span className="pi pi-arrow-left p-button-icon p-button-icon-left"></span>
                <span className="p-button-label">Voltar </span>
              </Button>
            </div>
            <div className="field col-12 md:col-4">
              <Button type="button" onClick={cadastroProrrogacao}>
                <span className="p-button-label">Cadastrar</span>
              </Button>
            </div>
            <div className="field col-12 md:col-4 ">
              <Button type="button" onClick={getItemsProrrogacoes}>
                <span className="p-button-label">Pesquisar</span>
              </Button>
            </div>
          </div>
        </form>
      </Fieldset>
      {visibleItemsProrrogado && (
        <ItensProrrogacao
          exercicio={exercicio.exercicio}
          programaSelected={programaSelected}
          prorrogacoesList={prorrogacoesList}
          cronograma={cronograma}
          programasList={programasList}
          acoesList={acoesList}
          indicadoresList={indicadoresList}
          setAtualizaList={setAtualizaList}
        />
      )}
      {visibleCadastroProrrogacao && (
        <CadastroProrrogacao
          programaSelected={programaSelected}
          exercicio={exercicio.exercicio}
          cronograma={cronograma}
          programasList={programasList}
          acoesList={acoesList}
          indicadoresList={indicadoresList}
          setVisibleCadastroProrrogacao={setVisibleCadastroProrrogacao}
          visibleCadastroProrrogacao={visibleCadastroProrrogacao}
          setAtualizaList={setAtualizaList}
        />
      )}
    </CardSeplag>
  );
};

export default Prorrogacao;
